import React from "react";
import { axiosV2 } from "../../../utils/BasicAuthAPI";
import moment from "moment";
import "../audit.css";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
  Table,
} from "antd";
import { Link } from "react-router-dom";
import SearchAuditModal from "../Search/SearchAuditModal";
import CreateAndEditAuditPage from "../Create/CreateAndEditAuditPage";
import AuditReportViewModal from "../AuditReportView/AuditReportViewModal";
import liracrypt from "../../Liracrypt/liracrypt";

export default class ListAudit extends React.Component {
  state = {
    visible: false,
    addEditModalVisible: false,
    disabledBtn: false,
    AuditLines: { loaded: false, data: [] },
    AuditType: { loaded: false, data: [] },
    AuditSubType: { loaded: false, data: [] },
    AuditUsers: { loaded: false, data: [] },
    data: [],
    searchData: {
      typ: "all",
      subTyp: "all",
      lid: "all",
      tgt: "all",
      auditor: "all",
      auditee: "all",
      status: "all",
      from: moment().startOf("month").format("YYYY/MM/DD"),
      to: moment().endOf("month").format("YYYY/MM/DD"),
    },
    editData: null,
  };
  formRef = React.createRef();

  modelCloseHandler = (data, searchData, withData) => {
    let tblData = this.state.data;
    if (withData) {
      tblData = data.data.map((obj) => {
        return { ...obj, key: obj["_id"] };
      });
    }
    this.setState({ data: tblData, visible: false, searchData: searchData });
  };

  addEditModelCloseHandler = (refetch) => {
    if (refetch) {
      this.fetchData();
    }
    this.setState({ addEditModalVisible: false });
  };

  handleAddEditModalDisplay = (record) => {
    let obj = null;
    if (record) {
      obj = {
        id: record["_id"],
        TYP: record["typ"],
        SUBTYP: record["subTyp"],
        LID: record["lid"],
        Status: record["status"],
        Auditor: record["auditor"],
        Auditee: record["auditee"],
        Team: record["tean"],
        AuditDt: moment(record["audDt"], "YYYY/MM/DD"),
      };
    }
    this.setState({ addEditModalVisible: true, editData: obj });
  };

  fetchLine = () => {
    const that = this;
    liracrypt
      .get("/mdict", {
        typ: "Line",
        subTyp: "idame",
      })
      .then((res, req) => {
        let data = res.data;
        const keys = Object.keys(data["data"]);
        const resData = keys.map((key) => {
          return { id: key, name: data["data"][key] };
        });
        that.setState({ AuditLines: { loaded: true, data: resData } });
      })
      .catch(function (error) {
        console.log("Error****: fetch calendar");
      });
  };
  fetchType = () => {
    const that = this;
    liracrypt
      .get("/mdict", {
        typ: "AuditTypes",
        subTyp: "idame",
      })
      .then((res, req) => {
        let data = res.data;
        const resData = data["data"].map((obj) => {
          return { id: Object.keys(obj)[0], name: Object.values(obj)[0] };
        });
        that.setState({ AuditType: { loaded: true, data: resData } });
      })
      .catch(function (error) {
        console.log("Error****: fetch calendar");
      });
  };
  fetchSubType = () => {
    const that = this;
    liracrypt
      .get("/mdict", {
        typ: "AuditSubTypes",
        subTyp: "treeData",
      })
      .then((res, req) => {
        let data = res.data;
        const keys = Object.keys(data["data"]);
        const resData = keys.map((key) => {
          return { id: key, name: data["data"][key] };
        });
        that.setState({ AuditSubType: { loaded: true, data: resData } });
      })
      .catch(function (error) {
        console.log("Error****: fetch calendar");
      });
  };
  fetchUser = () => {
    const that = this;
    liracrypt
      .get("/mdict", {
        typ: "User",
        subTyp: "idame",
      })
      .then((res, req) => {
        let data = res.data;
        const keys = Object.keys(data["data"]);
        const resData = keys.map((key) => {
          return { id: key, name: data["data"][key] };
        });
        that.setState({ AuditUsers: { loaded: true, data: resData } });
      })
      .catch(function (error) {
        console.log("Error****: fetch calendar");
      });
  };

  fetchData = () => {
    liracrypt
      .get("/audit/session", this.state.searchData)
      .then((res, req) => {
        let data = res.data;
        // const msg = data["Message"] ? data["Message"] : "Successfully Added!";
        // message.success(msg, 4)
        this.setState({
          data: data.data.map((obj) => {
            return { ...obj, key: obj["_id"] };
          }),
        });
        // that.formRef.current.resetFields();
        // props.sendBackData(data)
      })
      .catch(function (error) {
        message.error("ERROR: Unable to add!!", 2);
        console.log("Error****: fetch calendar", error);
        // setState({ ...state, disabledBtn: false });
      });
  };

  componentDidMount = () => {
    // if (this.state.currentEvents.length === 0) {
    //     this.fetchEvents();
    // }
    if (!this.state.AuditLines.loaded) {
      this.fetchLine();
    }
    if (!this.state.AuditType.loaded) {
      this.fetchType();
    }
    if (!this.state.AuditSubType.loaded) {
      this.fetchSubType();
    }
    if (!this.state.AuditUsers.loaded) {
      this.fetchUser();
    }

    if (this.state.data.length === 0) {
      this.fetchData();
    }
  };

  componentWillUnmount = () => {
    delete this.state;
  };

  render() {
    const columns = [
      {
        title: "Audit Session",
        children: [
          {
            title: "Date",
            dataIndex: "audDt",
            key: "audDt",
          },
          {
            title: "Line",
            dataIndex: "lineName",
            key: "lineName",
            width: 150,
          },
          {
            title: "SubType",
            dataIndex: "subTyp",
            key: "subTyp",
          },
          {
            title: "Auditor",
            dataIndex: "auditorName",
            key: "auditorName",
            width: 150,
          },
          {
            title: "Auditee",
            dataIndex: "auditeeName",
            key: "auditeeName",
            width: 150,
          },
          {
            title: "AuditStatus",
            dataIndex: "status",
            key: "status",
          },
          {
            title: "TotalClauses",
            dataIndex: "t_Count",
            key: "t_Count",
          },
        ],
      },
      {
        title: "Audit Completion",
        className: "lightBlue",
        children: [
          {
            title: "Open",
            dataIndex: "st_Aud_O_Count",
            key: "st_Aud_O_Count",
            className: "lightBlue",
          },
          {
            title: "Close",
            dataIndex: "st_Aud_C_Count",
            key: "st_Aud_C_Count",
            className: "lightBlue",
          },
        ],
      },
      {
        title: "Compliance",
        className: "lightGray",
        children: [
          {
            title: "Meets",
            dataIndex: "g_Count",
            key: "g_Count",
            className: "lightGray",
          },
          {
            title: "Partially meets",
            dataIndex: "o_Count",
            key: "o_Count",
            className: "lightGray",
          },
          {
            title: "Does Not meet",
            dataIndex: "r_Count",
            key: "r_Count",
            className: "lightGray",
          },
          {
            title: "NA",
            dataIndex: "w_Count",
            key: "w_Count",
            className: "lightGray",
          },
        ],
      },
      {
        title: "Closure",
        className: "lightVoilet",
        children: [
          {
            title: "Open",
            dataIndex: "st_Close_o_Count",
            key: "st_Close_o_Count",
            className: "lightVoilet",
          },
          {
            title: "Close",
            dataIndex: "st_Close_C_Count",
            key: "st_Close_C_Count",
            className: "lightVoilet",
          },
        ],
      },
      {
        title: "",
        children: [
          {
            title: "Action",
            key: "action",
            render: (text, record) => (
              <React.Fragment>
                <Button
                  htmlType="button"
                  className="login-form-button gx-mt-1 bigBtn"
                  onClick={() => this.handleAddEditModalDisplay(record)}
                >
                  <span className="gx-link">Edit</span>
                </Button>
                <Link to={`audit-report/${record._id}`}>
                  <Button
                    htmlType="button"
                    className="login-form-button gx-mt-1 bigBtn"
                    onClick={() => this.handleAddEditModalDisplay(record)}
                  >
                    <span className="gx-link">View</span>
                  </Button>
                </Link>
              </React.Fragment>
            ),
          },
        ],
      },
    ];

    return (
      <div className="AuditSection ListAudit" style={{ padding: "20px" }}>
        <div className="tableContainer">
          <div className="formBtnGroup" style={{ textAlign: "end" }}>
            <Button
              type="primary"
              style={{ marginRight: "10px" }}
              onClick={() => {
                this.setState({ visible: true });
              }}
              className="login-form-button gx-mt-1 bigBtn"
            >
              Search
            </Button>

            <Button
              style={{ textAlign: "center" }}
              onClick={() => this.handleAddEditModalDisplay()}
              type="primary"
              htmlType="button"
              className="login-form-button gx-mt-1 bigBtn"
            >
              {"Create Audit Session"}
            </Button>
          </div>
          <div className="formBtnGroup" style={{ textAlign: "end" }}></div>

          <h4 className="title">Audit Session</h4>
          {this.state.data ? (
            <>
              <Table
                className="ThemeTable"
                columns={columns}
                dataSource={this.state.data}
                scroll={{ x: 1400 }}
              />
              <SearchAuditModal
                visible={this.state.visible}
                modelCloseHandler={this.modelCloseHandler}
                AuditLines={this.state.AuditLines.data}
                AuditType={this.state.AuditType.data}
                AuditUsers={this.state.AuditUsers.data}
                searchtData={this.state.searchData}
              />
              <CreateAndEditAuditPage
                setPageHeader={this.props.setPageHeader}
                visible={this.state.addEditModalVisible}
                modelCloseHandler={this.addEditModelCloseHandler}
                AuditLines={this.state.AuditLines.data}
                AuditType={this.state.AuditType.data}
                AuditUsers={this.state.AuditUsers.data}
                editData={this.state.editData}
              />
              <AuditReportViewModal
                visible={this.state.addEditModalVisible}
                modelCloseHandler={this.addEditModelCloseHandler}
                AuditLines={this.state.AuditLines.data}
                AuditType={this.state.AuditType.data}
                AuditUsers={this.state.AuditUsers.data}
                editData={this.state.editData}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
}
